<template>
  <el-popover placement="bottom" width="350" trigger="click">
    <el-tabs @tab-click="tabChange" v-model="activeName">
      <el-tab-pane :label="`全部(${pagination.total ? pagination.total : 0})`" name="first" />
      <el-tab-pane
        :label="`未读(${localPagination.total ? localPagination.total : 0})`"
        name="second"
      />
    </el-tabs>
    <!-- <div class="font-16 font-weight text-center padding-bottom-5" style="border-bottom: 1px solid #f6f6f6">消息列表</div> -->
    <el-scrollbar style="height: 300px" v-loading="loading">
      <!-- <avue-notice @click="handleClick" :data="data" :option="option" @page-change="pageChange"></avue-notice> -->
      <template v-if="noticeList.length > 0 && activeName === 'first'">
        <div
          @click="handleClick(item)"
          style="cursor: pointer"
          class="padding-x-5 padding-y-10 notice-item"
          v-for="item in noticeList"
          :key="item.id + 'all'"
        >
          <div class="flex-between margin-bottom-2" style="width: 90%">
            <span class="font-14">{{ item.title }}</span>
            <el-tag size="mini" type="info" v-if="item.readTime">已读</el-tag>
            <el-tag size="mini" type="warning" v-else>未读</el-tag>
          </div>
          <div class="one-line">{{ item.remark }}</div>
          <span class="font-12 color-999">{{ item.createTime }}</span>
        </div>
      </template>
      <template v-if="unReadList.length > 0 && activeName === 'second'">
        <div
          @click="handleClick(item)"
          style="cursor: pointer"
          class="padding-x-5 padding-y-10 notice-item"
          v-for="item in unReadList"
          :key="item.id + 'todo'"
        >
          <div class="flex-between margin-bottom-2" style="width: 90%">
            <span class="font-14">{{ item.title }}</span>
          </div>
          <div class="one-line">{{ item.remark }}</div>
          <span class="font-12 color-999">{{ item.createTime }}</span>
        </div>
      </template>
      <el-empty
        description="空空如也"
        v-if="
          ((noticeList.length === 0 && activeName === 'first') ||
            (unReadList.length === 0 && activeName === 'second')) &&
          !loading
        "
      />
    </el-scrollbar>
    <div
      v-if="activeName === 'first' && pagination.pages > 1 && pagination.page < pagination.pages"
      @click="loadMore"
      class="flex-center padding-top-5"
    >
      <el-button type="text">加载更多</el-button>
    </div>
    <div
      v-if="
        activeName === 'second' &&
        localPagination.pages > 1 &&
        localPagination.page < pagination.pages
      "
      @click="loadMore"
      class="flex-center padding-top-5"
    >
      <el-button type="text">加载更多</el-button>
    </div>
    <div slot="reference" style="cursor: pointer">
      <el-badge :hidden="localPagination.total === 0" :value="localPagination.total">
        <!-- <i class="el-icon-bell"></i> -->
        <div class="flex-center flex-col">
          <img src="@/static/icon_top_notice.png" alt="" style="width: 22px; height: 22px" />
          <span class="color-666 font-12">消息</span>
        </div>
      </el-badge>
    </div>
    <!--消息详情-->
    <el-dialog append-to-body :visible.sync="msgVisible" width="350px">
      <div slot="title" class="msg-tip-title">
        <span>{{ msgTitle }}</span>
      </div>
      <p class="msg-tip-content" style="margin: 0 0 0 30px">{{ msgContent }}</p>
      <el-row style="margin-top: 18px">
        <el-col align="center">
          <el-button
            type="primary"
            size="mini"
            @click="msgVisible = false"
            style="background: #4292ff"
            >我知道了</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!--公告详情-->
    <announcement-dialog ref="announcementDialog" />
    <SettleDetail ref="settle" />
    <!-- 证照预警 -->
    <LicenseExpireWarning ref="licenseEcpireWarning" />
  </el-popover>
</template>

<script>
  import { getNoticeListDesc, getNoticeListUnRead, readNotice } from '@/api'
  import announcementDialog from '@/components/announcement-dialog/announcement-dialog'
  import SettleDetail from './settle-detail.vue'
  import { urlParams } from '@/util'
  import LicenseExpireWarning from '@/components/license-expire-warning'

  let timeId = null
  const list = [
    {
      title: '新系统上线测试',
      subtitle: '2021-11-13 00:00:00',
      tag: '已经超时',
      status: 0
    },
    {
      title: '新系统上线测试',
      subtitle: '2021-11-13 00:00:00',
      tag: '已经超时',
      status: 1
    },
    {
      title: '新系统上线测试',
      subtitle: '2021-11-13 00:00:00',
      status: 3,
      tag: '有错误'
    },
    {
      title: '新系统上线测试',
      subtitle: '2021-11-13 00:00:00',
      status: 4,
      tag: '已完成'
    }
  ]
  export default {
    name: 'top-notice',
    components: { announcementDialog, SettleDetail, LicenseExpireWarning },
    data() {
      return {
        msgVisible: false,
        msgTitle: '',
        msgContent: '',
        activeName: 'first',
        option: {
          props: {
            img: 'img',
            title: 'title',
            subtitle: 'remark',
            tag: 'tag',
            status: 'type'
          }
        },
        data: list,
        noticeList: [],
        unReadList: [],
        loading: false,
        localPagination: {
          page: 1,
          pages: 0,
          total: 0,
          pageSize: 10
        }
      }
    },
    created() {
      this.initNoticeInfo()
      this.getList()
      this.getUnList()
    },
    mounted() {
      const bodyElement = document.querySelector('body')
      bodyElement.appendChild(this.$refs.licenseEcpireWarning.$el)
    },
    methods: {
      loadMore() {
        if (this.activeName === 'first') {
          this.pagination.page += 1
          if (this.pagination.page > this.pagination.pages) {
            return
          }
          this.getList()
          return
        }
        if (this.activeName === 'second') {
          this.localPagination.page += 1
          if (this.localPagination.page > this.localPagination.pages) {
            return
          }
          this.getUnList()
        }
      },
      handleClick(item) {
        const { metaData = {}, id, title, remark } = item
        const meta = JSON.parse(metaData)
        const { link, bizId } = meta
        if (!item.readTime && id) {
          this.setRead(id)
        }
        // 车司审核
        if (item.type === 8) {
          this.goWorkDetail(link)
          return
        }
        if (item.type === 9) {
          // 公告
          this.getAnnouncementDetail(bizId)
          return
        }
        if (item.type === 18) {
          this.$refs.settle.init({
            link,
            bizId,
            title,
            remark
          })
          return
        }
        if (item.type === 19) {
          const obj = { link: meta.bizId, time: item.createTime }
          this.$refs.licenseEcpireWarning.init(obj)
          return
        }
        if (link) {
          // 如果是去详情页，先去模块首页再跳转详情，避免面包屑不会变动
          if (link.includes('/customer/complaint/detail')) {
            // 投诉建议
            this.$router.push('/customer/complaint/list')
          } else if (link.includes('/customer/workOrder/workDetail')) {
            // 工单
            this.$router.push('/customer/workOrder/index')
          }

          this.$router.push(link)
        } else {
          const { detail } = JSON.parse(metaData)
          this.msgContent = detail || remark
          this.msgTitle = title
          this.msgVisible = true
        }
      },
      // 跳转工单详情页
      goWorkDetail(url) {
        const workDetailParam = urlParams(url)
        this.$store.commit('SET_WORK_DETAIL_PARAM', workDetailParam)
        this.$router.push({ path: '/customer/workOrder/index' })
      },
      // 设置已读
      setRead(id) {
        readNotice({ id }).then(() => {
          this.pagination.page = 1
          this.localPagination.page = 1
          this.getList()
          this.getUnList()
        })
      },
      // 打开公告详情弹窗
      getAnnouncementDetail(id) {
        if (!id) {
          this.$message.error('没有获取到公告ID，无法查看详情')
          return
        }
        this.$refs.announcementDialog.init(id)
      },
      initNoticeInfo() {
        this.$store.dispatch('subScribeMessage', (res) => {
          const { mustClick, metaData: { link } = {} } = res
          if (timeId) {
            clearTimeout(timeId)
          }
          timeId = setTimeout(() => {
            this.pagination.page = 1
            clearTimeout(timeId)
            timeId = null
            this.getList()
          }, 1200)

          if (mustClick) {
            this.$confirm(res.remark, res.title, {
              confirmButtonText: '去处理',
              cancelButtonText: '稍后处理',
              lockScroll: true,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              closeOnHashChange: false,
              showClose: false,
              type: 'warning'
            })
              .then(() => {
                if (link) {
                  this.$router.push(link)
                }
              })
              .catch(() => {})
          } else {
            this.$notify.info({
              title: res.title,
              message: res.remark,
              duration: 0,
              customClass: 'all-notify'
            })
          }
        })
      },
      async getList() {
        try {
          this.loading = true
          const { code, data } = await getNoticeListDesc({
            page: this.pagination.page,
            size: this.pagination.pageSize
          })

          if (code === 0) {
            const { records = [], total, current, pages } = data
            // const wrapList = records.map((item) => ({
            //   title: item.title,
            //   subtitle: item.remark,
            //   status: item.type,
            //   tag: ''
            // }))
            if (current === 1) {
              this.noticeList = records
            } else {
              this.noticeList.push(...records)
            }
            this.pagination = {
              ...this.pagination,
              total,
              page: current,
              pages
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      tabChange() {
        if (this.activeName === 'first') {
          this.pagination.page = 1
          this.getList()
          return
        }
        if (this.activeName === 'second') {
          this.localPagination.page = 1
          this.getUnList()
        }
      },
      async getUnList() {
        try {
          this.loading = true
          const { code, data } = await getNoticeListUnRead({
            page: this.localPagination.page,
            size: this.localPagination.pageSize
          })

          if (code === 0) {
            const { records = [], total, current, pages } = data
            if (current === 1) {
              this.unReadList = records
            } else {
              this.unReadList.push(...records)
            }
            this.localPagination = {
              ...this.localPagination,
              total,
              page: current,
              pages
            }
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async pageChange(page, done) {
        if (this.pagination.pages < 2) {
          done()
          return
        }
        this.pagination.page = page
        await this.getList()
        done()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .notice-item {
    border-bottom: 1px solid #f6f6f6;
  }
  .one-line {
    max-width: 80%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ::v-deep .el-dialog {
    border-radius: 8px;
  }
  ::v-deep .el-dialog__body {
    padding: 5px 20px;
  }
  .msg-tip-title {
    display: flex;
    align-items: center;
    color: #303133;
    font-size: 16px;
    font-weight: 500;
  }
  .msg-tip-content {
    font-size: 14px;
    color: #606266;
    white-space: pre-wrap;
    word-break: break-all;
    line-height: 32px;
  }
  ::v-deep .el-badge__content {
    background-color: #fa5151;
  }
</style>
<style>
  .all-notify {
    top: 25px !important;
  }
</style>
